<div class="fullwidth">
  <div class="particles"><canvas repulse-particles [size]="1" number=110 speed="2" linkDistance="180" linkWidth="1" repulseDistance="200" linkHex="rgba(255,255,255,0.5)" particleHex="rgba(255,255,255,0.5)" [bounce]="false"></canvas></div>
  <div class="limiter">
    <div class="row">
      <div class="tagline"><b>развиваем</b><b>нормы</b><b>создаем</b><b>будущее</b></div>
      <div class="promo"><homepage-promo></homepage-promo></div>
    </div>
  </div>
</div>
